import type { IChatCenterState } from '../../domain';
import { ApiBaseService } from '../api-base-service';

export class ChatApiService extends ApiBaseService {
    constructor(context = '/delegate/chat/v1') {
        super(context);
    }

    async getChatCenterState(): Promise<IChatCenterState> {
        try {
            const { data: chatCenterState } = await this.http.get<IChatCenterState>(`/chatCenterState`);

            return chatCenterState;
        } catch {
            return 'OFFLINE';
        }
    }
}
